import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { KomDom } from "../../models/nl-models/komdom-calculation.model";

@Injectable()
export class NLCalculatorService {

    constructor(
        private httpClient: HttpClient
    ) { }

    komDomCalculation = (komDom: KomDom) => {
        return this.httpClient.post('api/calculator/komdom', komDom).toPromise()
    }

    komDomValues = (type: number, area: number) => {
        return this.httpClient.post<{ insuredSumList: Array<number>, objectValueEUR: number }>('api/calculator/komdom/getavailableinsurancesums', { ObjectType: type, SurfaceArea: area }).toPromise()
    }

    exportInfoOffer = (info: any) => {
        return this.httpClient.post('api/nloffers/generatepdf', info, { observe: 'response', responseType: 'blob' }).toPromise()
    }

    getExchangeRate(date: string) {
        return this.httpClient.get<{ result: { eur: { sre: string } } }>('api/conversionrates/' + date).toPromise()
    }

    downloadVinculation() {
        return this.httpClient.post('api/vinculation/download', {
            AgentName: 'NENAD BABIĆ',
            PolicyNo: '778899',
            VinculationNo: '998877',
            InsurancePeriod: '1',
            Duration: 6,
            InsuranceObject: 'STAN',
            PackageName: 'MASIVNA',
            SumInsured: 4000,
            InsureeName: 'MARKO LOŠONC',
            JMBG: '1905990762077',
            Address: 'BULEVAR ARSENIJA ČARNOJEVIĆA 72',
            PhoneNumber: '0624192124',
            TransferName: 'MARIJA DAKIĆ',
            TransferMB: '006126172',
            TransferAddress: 'BULEVAR MILUTINA MILANKOVIĆA 117',
            TransferPhoneNumber: '0631827124'
        }, { observe: 'response', responseType: 'blob' }).toPromise()
    }

}